import {
	FeedbackQuestionList,
	FeedbackQuestionService,
	FeedbackQuestionsEvaluationCard,
	FeedbackService,
	Id,
	Loading,
	Section,
} from "@dgs/core";
import { useDetailsQuery } from "@dgs/core/lib/api/baseQueries";
import { FC } from "react";
import styled from "styled-components";
import { FeedbackSettingsCardWithPreview } from "./FeedbackSettingsCardWithPreview";

const Wrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: ${({ theme }) => theme.spacing(4)};

	${({ theme }) => theme.breakpoints.largeDesktop} {
		grid-template-columns: minmax(380px, 1fr) 3fr;
	}
`;

const StyledSection = styled(Section)`
	max-width: 110rem;
	padding: 0;
`;

interface Props {
	feedbackId: Id;
	feedbackService: FeedbackService;
	feedbackQuestionService: FeedbackQuestionService;
	canUpdate: boolean;
	canDelete: boolean;
	previewUrl: string;
}

export const FeedbackDetailsWithPreview: FC<Props> = ({
	canUpdate,
	canDelete,
	feedbackId,
	feedbackService,
	feedbackQuestionService,
	previewUrl,
}) => {
	const { data: feedback, isLoading } = useDetailsQuery(feedbackId, feedbackService);

	if (!feedback) {
		return <Loading />;
	}

	return (
		<StyledSection>
			<Wrapper>
				<FeedbackSettingsCardWithPreview
					feedback={feedback}
					service={feedbackService}
					canUpdate={canUpdate}
					canDelete={canDelete}
					previewUrl={previewUrl}
				/>
				{!feedback.hasAnswers && (
					<FeedbackQuestionList
						canUpdate={canUpdate}
						isLoading={isLoading}
						feedback={feedback}
						service={feedbackQuestionService}
						additionalInvalidateQueryKeys={[feedbackService.indexKey]}
					/>
				)}
				{feedback.hasAnswers && (
					<FeedbackQuestionsEvaluationCard service={feedbackQuestionService} questions={feedback.questions} />
				)}
			</Wrapper>
		</StyledSection>
	);
};
